/**
 * Default portal palette, taken from the Partner Hub design: a deep navy chrome with an amber accent.
 * A tenant's own primary and secondary colors, set in the CRM, override these.
 */
export const PORTAL_DEFAULT_PRIMARY = "#B45309";
export const PORTAL_DEFAULT_SECONDARY = "#131B2A";
